import { routes } from "../../../routers/routes";
import Breadcrumbs from "../../commonComponents/breadcrumbs";
import GridView from "../../commonComponents/gridView";

const CarRightListContainer = () => {
  return (
    <>
      <Breadcrumbs title="Car Shop" url={routes.Home.CarDemo1} mainClass="car-breadcrumbs-section" />
      <GridView type="car" gridType="list-view" gridSize={1} sectionClass="car-shop-section car-product-section" filterTagsClass="car-list-header" side="right" />
    </>
  );
};

export default CarRightListContainer;
